import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  configure,
} from 'vee-validate'
import {
  email,
  max,
  min,
  numeric,
  required,
  // eslint-disable-next-line camelcase
  required_if,
  between,
    // eslint-disable-next-line camelcase
  max_value,
    // eslint-disable-next-line camelcase
  min_value,
} from 'vee-validate/dist/rules'
import i18n from '@/i18n'

extend('email', email)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('required', required)
extend('required_if', required_if)
extend('between', between)
extend('max_value', max_value)
extend('min_value', min_value)

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`)
    return i18n.t(`validations.${values._rule_}`, values)
  },
})

// extend('decimal', {
//   validate: (value, { decimals = '*', separator = '.' } = {}) => {
//     if (value === null || value === undefined || value === '') {
//       return { valid: false }
//     }
//     if (Number(decimals) === 0) {
//       return {
//         valid: /^-?\d*$/.test(value),
//       }
//     }
//     const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
//     const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`)

//     return {
//       valid: regex.test(value),
//     }
//   },
//   message: 'The {_field_} field must contain only decimal values',
// })
